import { Button, ButtonProps } from '../shadcn'
import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'
import { forwardRef } from 'react'

export const AsyncButton = forwardRef<HTMLButtonElement, ButtonProps & { loading?: boolean }>(
  ({ children, loading, disabled, ...props }, ref) => {
    return (
      <Button ref={ref} disabled={disabled || loading} {...props}>
        {loading && <Loader2 className="absolute h-4 w-4 animate-spin" />}
        <div className={cn('flex min-w-0 items-center gap-2', { invisible: loading })}>{children}</div>
      </Button>
    )
  }
)

AsyncButton.displayName = 'AsyncButton'
